// ViewInvoiceCharges.jsx
import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewInvoiceCharges = ({ invoiceCharge }) => {
  if (!invoiceCharge) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Invoice Charge Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Item Description: {invoiceCharge.itemDescription}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Price: {invoiceCharge.price}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            GL Code: {invoiceCharge.glCode}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewInvoiceCharges;
